import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

// project import
import Loadable from 'components/Loadable'
//import MainLayout from 'layout/MainLayout'
import DashboardLayout from 'layout/Dashboard'
import AuthGuard from "../guards/AuthGuards"

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/DashboardTabs')))

const TreatmentHistory = Loadable(lazy(() => import('pages/dashboard/TreatmentHistory')))
const OrderHistory = Loadable(lazy(() => import('pages/dashboard/OrderHistory')))
const ReceiptHistory = Loadable(lazy(() => import('pages/dashboard/ReceiptHistory')))
const BillHistory = Loadable(lazy(() => import('pages/dashboard/BillHistory')))
const PaymentHistory = Loadable(lazy(() => import('pages/dashboard/PaymentHistory')))
const CreditHistory = Loadable(lazy(() => import('pages/dashboard/CreditHistory')))
//const FamilyCreditSessionHistory = Loadable(lazy(() => import('pages/dashboard/FamilyCreditSessionHistory')))

// render - sample page
const UsersTable = Loadable(lazy(() => import('pages/users/UsersTable')))
const UserDetail = Loadable(lazy(() => import('pages/users/UserDetail')))
const UserEdit = Loadable(lazy(() => import('pages/users/UserEdit')))
const UserCreate = Loadable(lazy(() => import('pages/users/UserCreate')))
const UserShift = Loadable(lazy(() => import('pages/users/UserShift')))
const UserTemporarilyShift = Loadable(lazy(() => import('pages/users/UserTemporarilyShift')))
const UserTimeOff = Loadable(lazy(() => import('pages/users/UserTimeOff')))
const TreatmentRateSetting = Loadable(lazy(() => import('pages/users/TreatmentRateSettingTable')))

const ClientTable = Loadable(lazy(() => import('pages/client/ClientTable')))
const ClientDetail = Loadable(lazy(() => import('pages/client/ClientDetail')))
const ClientEdit = Loadable(lazy(() => import('pages/client/ClientEdit')))
const ClientCreate = Loadable(lazy(() => import('pages/client/ClientCreate')))
const ClientMachineList = Loadable(lazy(() => import('pages/client/ClientMachineList')))
const ClientHistoryPage = Loadable(lazy(() => import('pages/client/ClientHistoryPage')))
const ClientWaitlistEdit = Loadable(lazy(() => import('pages/client/ClientWaitlistEdit')))
const ClientIntakeFormPage = Loadable(lazy(() => import('pages/client/ClientIntakeFormPage')))

const CategoryTable = Loadable(lazy(() => import('pages/category/CategoryTable')))
const CategoryCreate = Loadable(lazy(() => import('pages/category/CategoryCreate')))
const CategoryEdit = Loadable(lazy(() => import('pages/category/CategoryEdit')))
const SubCategoryTable = Loadable(lazy(() => import('pages/category/SubCategoryTable')))

const ProductTable = Loadable(lazy(() => import('pages/product/ProductTable')))
const ProductCreate = Loadable(lazy(() => import('pages/product/ProductCreate')))
const ProductEdit = Loadable(lazy(() => import('pages/product/ProductEdit')))

const PackageCreate = Loadable(lazy(() => import('pages/product/PackageCreate')))
const PackageEdit = Loadable(lazy(() => import('pages/product/PackageEdit')))

const ReceiptTable = Loadable(lazy(() => import('pages/receipt/ReceiptTable')))
const ReceiptEdit = Loadable(lazy(() => import('pages/receipt/ReceiptEdit')))
const ReceiptCopy = Loadable(lazy(() => import('pages/receipt/ReceiptCopy')))
const ReceiptPrint = Loadable(lazy(() => import('pages/receipt/ReceiptPrintPanel')))
const MultiReceiptsPrint = Loadable(lazy(() => import('pages/receipt/MultiReceiptsPrintPanel')))

//const BillTabs = Loadable(lazy(() => import('pages/bill/BillTabs')))
const BillTable = Loadable(lazy(() => import('pages/bill/BillsList')))
const BillEdit = Loadable(lazy(() => import('pages/bill/BillEdit')))

const PaymentTable = Loadable(lazy(() => import('pages/payment/PaymentTable')))
const PaymentDetailsPage = Loadable(lazy(() => import('pages/payment/PaymentDetails')))

const CreditTable = Loadable(lazy(() => import('pages/credit/CreditTable')))
const CreditEdit = Loadable(lazy(() => import('pages/credit/CreditEdit')))
const FamilyCreditSessionByProductTable = Loadable(lazy(() => import('pages/credit/familySessionbyproductTable')))
//  const FamilyBalancePage = Loadable(lazy(() => import('pages/credit/FamilyBalancePage')))
const FamilyProductHistory = Loadable(lazy(() => import('pages/credit/FamilyProductHistory')))
const FamilyHistoryCreditTable = Loadable(lazy(() => import('pages/credit/FamilyHistoryCreditTable')))
const InitialFamilyCreditTable = Loadable(lazy(() => import('pages/credit/InitialFamilyCreditPage')))
const InitialTreatmentBalance = Loadable(lazy(() => import('pages/credit/InitialTreatmentBalance')))
const FamilyCreditBalance = Loadable(lazy(() => import('pages/credit/FamilyCreditBalanceTable')))

const LicenceTable = Loadable(lazy(() => import('pages/licence/LicenceTable')))
const LicenceEdit = Loadable(lazy (() => import('pages/licence/LicenceEdit')))
const LicenceCreate = Loadable(lazy (() => import('pages/licence/LicenceCreate')))
const LicenceBoard = Loadable(lazy(() => import('pages/licence/LicenceBoard')))

//const OrderTable = Loadable(lazy(() => import('pages/orders/OrdersTable')))
const OrderCopy = Loadable(lazy(() => import('pages/orders/OrderCopy')))
const OrderEdit = Loadable(lazy(() => import('pages/orders/OrderEdit')))
const OrdersTabsPage = Loadable(lazy(() => import('pages/orders/OrderTabsPage')))
//const CustomerOrderDetailsDialog = Loadable(lazy(() => import('pages/orders/CustomerOrderDetailsDialog')))
//const CustomerOrderDetailsEdit   = Loadable(lazy(() => import('pages/orders/CustomerOrderDetailsEdit')))
const CustomerOrderDetailsPage = Loadable(lazy(() => import('pages/orders/CustomerOrderDetailsPage')))

const PurchaseOrderTable = Loadable(lazy(() => import('pages/orders/PurchaseOrderTable')))
const PurchaseOrderCreate = Loadable(lazy(() => import('pages/orders/PurchaseOrderCreate')))
const PurchaseOrderEdit = Loadable(lazy(() => import('pages/orders/PurchaseOrderEdit')))

const LowStockList = Loadable(lazy(() => import('pages/orders/inventory')))

const AppointmentSchedule = Loadable(lazy(() => import('pages/calendar/AppointmentSchedule')))
const DailySchedule = Loadable(lazy(() => import('pages/calendar/DailySchedule')))
const LicenceSchedule = Loadable(lazy(() => import('pages/calendar/LicenceSchedule')))
const InsuranceSchedule = Loadable(lazy(() => import('pages/calendar/InsuranceSchedule')))
const ClientBookingPage = Loadable(lazy(() => import('pages/calendar/ClientBookingPage')))
const ClientSettingsPage = Loadable(lazy(() => import('pages/profile')))
const RoomTable = Loadable(lazy(() => import('pages/rooms/RoomTable')))
const RoomEdit = Loadable(lazy(() => import('pages/rooms/RoomEdit')))

const WageTable = Loadable(lazy(() => import('pages/wage/WageTable')))
const WageSummaryHome = Loadable(lazy(() => import('pages/wage-summary/WageSummaryHome')))
const WageSummaryDetail = Loadable(lazy(() => import('pages/wage-summary/WageSummaryDetail')))
const ReceiptSummaryHome = Loadable(lazy(() => import('pages/receipt-summary/ReceiptSummaryHome')))
const ReceiptSummaryDetail = Loadable(lazy(() => import('pages/receipt-summary/ReceiptSummaryDetail')))

const WageEdit = Loadable(lazy(() => import('pages/wage/WageEdit')))
const WageBoard = Loadable(lazy(() => import('pages/wage/WageBoard')))
const WageSummaryBoard = Loadable(lazy(() => import('pages/wage-summary/WageSummaryBoard')))

const TimesheetTable = Loadable(lazy(() => import('pages/timesheet/TimesheetTable')))
const TimesheetCreate = Loadable(lazy(() => import('pages/timesheet/TimesheetCreate')))
const TimesheetEdit = Loadable(lazy(() => import('pages/timesheet/TimesheetEdit')))
const TimesheetBoard = Loadable(lazy(() => import('pages/timesheet/TimesheetBoard')))

const CommissionTable = Loadable(lazy(() => import('pages/commission/CommissionTable')))
const CommissionBoard = Loadable(lazy(() => import('pages/commission/CommissionBoard')))

const FixedWageTable = Loadable(lazy(() => import('pages/fixed-wage/FixedWageTable')))

const SystemSettingScheduleSort = Loadable(lazy(() => import('pages/systemSetting/ScheduleSort')))
const SystemSettingCreditTypeTable = Loadable(lazy(() => import('pages/systemSetting/CreditTypeTable')))
const PagePermitTable = Loadable(lazy(() => import('pages/systemSetting/page-permit/PagePermitTable')))
const PagePermitEdit = Loadable(lazy(() => import('pages/systemSetting/page-permit/PagePermitEdit')))
const ModuleNavAclTable = Loadable(lazy(() => import('pages/systemSetting/module-nav/ModuleNavAclTable')))
const ModuleNavAclEdit = Loadable(lazy(() => import('pages/systemSetting/module-nav/ModuleNavAclEdit')))
const ReceiptTypeTable = Loadable(lazy(() => import('pages/systemSetting/receipt-type/ReceiptTypeTable')))

const CustomisedSettingTable = Loadable(lazy(() => import('pages/systemSetting/customised-setting/CustomisedSettingTable')))
const CustomisedSettingEdit = Loadable(lazy(() => import('pages/systemSetting/customised-setting/CustomisedSettingEdit')))  
const ClinicRuntimeSetting = Loadable(lazy(() => import('pages/systemSetting/ClinicRuntimeSetting')))

const UserWageTable = Loadable(lazy(() => import('pages/systemSetting/user-wage/UserWageTable')))
// const WageCategoryEdit = Loadable(lazy(() => import('pages/systemSetting/user-wage/WageCategoryEdit')))
const UserWageDetailTable = Loadable(lazy(() => import('pages/systemSetting/user-wage/UserWageDetailTable')))
const PaymentMethodSetting = Loadable(lazy(() => import('pages/systemSetting/PaymentMethodSetting')))

const ExpenseTable = Loadable(lazy(() => import('pages/expense/ExpenseTable')))
const ExpenseCreate = Loadable(lazy(() => import('pages/expense/ExpenseCreate')))
const ExpenseEdit = Loadable(lazy(() => import('pages/expense/ExpenseEdit')))

const SupplierTable = Loadable(lazy(() => import('pages/supplier/SupplierTable')))
const SupplierCreate = Loadable(lazy(() => import('pages/supplier/SupplierCreate')))
const SupplierEdit = Loadable(lazy(() => import('pages/supplier/SupplierEdit')))

const TreatmentConsumablesSettingsTable = Loadable(lazy(() => import('pages/treatment/TreatmentConsumablesSettingsTable')))
const TreatmentConsumablesTable = Loadable(lazy(() => import('pages/treatment/TreatmentConsumablesTable')))
const TreatmentUsageList = Loadable(lazy(() => import('pages/treatment/TreatmentUsageList')))
const TreatmentUsageDetail = Loadable(lazy(() => import('pages/treatment/TreatmentUsageDetail')))

const InventoryTable = Loadable(lazy(() => import('pages/inventory/InventoryTable')))
const InitialInventoryTable = Loadable(lazy(() => import('pages/inventory/InitialInventoryTable')))
const InitialInventoryCreate = Loadable(lazy(() => import('pages/inventory/InitialInventoryCreate')))
const InitialInventoryEdit = Loadable(lazy(() => import('pages/inventory/InitialInventoryEdit')))

const InventoryAdjustmentTable = Loadable(lazy(() => import('pages/inventory/InventoryAdjustmentTable')))
const InventoryAdjustmentCreate = Loadable(lazy(() => import('pages/inventory/InventoryAdjustmentCreate')))
const InventoryAdjustmentEdit = Loadable(lazy(() => import('pages/inventory/InventoryAdjustmentEdit')))
const InventoryBarChart = Loadable(lazy(() => import ('pages/inventory/ProductDailyBarPage')))

const SalesTable = Loadable(lazy(() => import('pages/manager-zone/SalesTable')))
const ManagerReport = Loadable(lazy(() => import('pages/manager-zone/ManagerReport')))
const RevenueTable = Loadable(lazy(() => import('pages/manager-zone/RevenueTable')))
const HelpTable = Loadable(lazy(() => import('pages/guides/HelpTable')))
const FixedExpensePage = Loadable(lazy(() => import('pages/manager-zone/FixedExpensePage')))
const VariableExpenseTable = Loadable(lazy(() => import('pages/manager-zone/VariableExpenseTable')))
const MonthlySummary = Loadable(lazy(() => import('pages/manager-zone/MonthlySummaryPage')))
const RevenueSummaryPage = Loadable(lazy(() => import('pages/manager-zone/RevenueSummaryPage')))
const StaffDailyReport = Loadable(lazy(() => import('pages/manager-zone/StaffDailyReport')))
const ClientGrowthEngine = Loadable(lazy(() => import('pages/manager-zone/ClientGrowthEngine')))
const ClientGrowthEngineHelp = Loadable(lazy(() => import('pages/manager-zone/ClientGrowthEngineHelp')))

const IntakePage = Loadable(lazy(() => import('pages/client/IntakeFormPage')))
const IntakeFormDetail = Loadable(lazy(() => import('pages/client/IntakeFormDetail')))
const UpdateIntakeForm = Loadable(lazy(() => import('components/UpdateIntakeForm')))
const GeneralConsentDetail = Loadable(lazy(() => import('pages/client/GeneralConsentDetailPage')))
const XeominConsentDetail = Loadable(lazy(() => import('pages/client/XeominConsentDetailPage')))
const XeominRepeatConsentDetail = Loadable(lazy(() => import('pages/client/XeominRepeatConsentDetailPage')))

const DailyReportPage = Loadable(lazy(() => import('pages/manager-zone/DailyReport')))

const AuthLogout = Loadable(lazy(() => import('pages/auth/Logout')))
const Error404 = Loadable(lazy(() => import('pages/general/Error404')))

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element:  <AuthGuard navId={'public'} component={<DashboardLayout />} />,
  children: [
    {
      path: 'dashboard',
      element: <AuthGuard navId={'dashboard'} component={<DashboardDefault />} />
    },
    {
      path: 'dashboard/:id',
      element: <AuthGuard navId={'dashboard'} component={<DashboardDefault />} />
    },
    {
      path: 'treatmentHistory',
      element: <AuthGuard navId={'treatmentHistory'} component={<TreatmentHistory />}/>
    },
    {
      path: 'orderHistory',
      element: <AuthGuard navId={'orderHistory'} component={<OrderHistory />}/>
    },
    {
      path: 'receiptHistory',
      element: <AuthGuard navId={'receiptHistory'} component={<ReceiptHistory />}/>
    },  
    {
      path: 'billHistory',
      element: <AuthGuard navId={'billHistory'} component={<BillHistory />}/>
    },
    {
      path: 'paymentHistory',
      element: <AuthGuard navId={'paymentHistory'} component={<PaymentHistory />}/>
    },
    {
      path: 'creditHistory',
      element: <AuthGuard navId={'creditHistory'} component={<CreditHistory />}/>
    },
    // {
    //   path: 'familyCreditSessionHistory',
    //   element: <AuthGuard navId={'familyCreditSessionHistory'} component={<FamilyCreditSessionHistory />}/>
    // },
    {
      path: 'users',
      element: <AuthGuard navId={'users'} component={<UsersTable />} />
    },
    // {
    //   path: 'users',
    //   element: <AuthGuard navId={'users'} component={<UsersTable />} />
    // },
    {
      path: 'user/detail/:id',
      element: <AuthGuard navId={'user'} component={<UserDetail />} />
    },
    {
      path: 'user/edit/:id',
      element: <AuthGuard navId={'user'} component={<UserEdit />} />
    },
    {
      path: 'user/shift/:id',
      element: <AuthGuard navId={'user'} component={<UserShift />} />
    },
    {
      path: 'user/temporarilyShift/:id',
      element: <AuthGuard navId={'user'} component={<UserTemporarilyShift />} />
    },
    {
      path: 'user/timeOff/:id',
      element: <AuthGuard navId={'user'} component={<UserTimeOff />} />
    },
    {
      path: 'user/create',
      element: <AuthGuard navId={'user'} component={<UserCreate />} />
    },
    {
      path: 'user/treatmentSetting',
      element: <AuthGuard navId={'user'} component={<TreatmentRateSetting />} />
    },
    {
      path: 'clients',
      element: <AuthGuard navId={'clients'} component={<ClientTable />}/>
    },
    {
      path: 'client/detail/:id',
      element: <AuthGuard navId={'client'} component={<ClientDetail />}/>
    },
    {
      path: 'client/edit/:id',
      element: <AuthGuard navId={'client'} component={<ClientEdit />} />
    },
    {
      path: 'client/create',
      element: <AuthGuard navId={'client'} component={<ClientCreate />} />
    },
    {
      path: 'client/meta',
      element: <AuthGuard navId={'client'} component={<ClientMachineList />} />
    },
    {
      path: 'client/history/:id',
      element: <AuthGuard navId={'client'} component={<ClientHistoryPage />} />
    },
    {
      path: 'client/waitlist/:id',
      element: <AuthGuard navId={'client'} component={<ClientWaitlistEdit />} />
    },
    {
      path: 'client/:id/intake',
      element: <AuthGuard navId={'client'} component={<ClientIntakeFormPage />} />
    },
    {
      path: 'intakeForm',
      element: <AuthGuard navId={'client'} component={<IntakePage />} />
    },
    {
      path: 'intake/:id',
      element: <AuthGuard navId={'client'} component={<IntakeFormDetail />} />
    },
    {
      path: 'intake/:id/update',
      element: <AuthGuard navId={'client'} component={<UpdateIntakeForm />} />
    },
    {
      path: 'general-consent/:id',
      element: <AuthGuard navId={'client'} component={<GeneralConsentDetail />} />
    },
    {
      path: 'xeomin-consent/:id',
      element: <AuthGuard navId={'client'} component={<XeominConsentDetail />} />
    },
    {
      path: 'xeomin-repeat-consent/:id',
      element: <AuthGuard navId={'client'} component={<XeominRepeatConsentDetail />} />
    },
    {
      path: 'categories',
      element: <AuthGuard navId={'category'} component={<CategoryTable />} />
    },
    {
      path: 'category/create',
      element: <AuthGuard navId={'category'} component={<CategoryCreate />} />
    },
    {
      path: 'category/edit/:id',
      element: <AuthGuard navId={'category'} component={<CategoryEdit />} />
    },
    {
      path: 'subCategories',
      element: <AuthGuard navId={'subcategory'} component={<SubCategoryTable />} />
    },
    {
      path: 'products',
      element: <AuthGuard navId={'products'} component={<ProductTable />} />
    },
    {
      path: 'product/create',
      element: <AuthGuard navId={'product'} component={<ProductCreate />} />
    },
    {
      path: 'product/edit/:id',
      element: <AuthGuard navId={'product'} component={<ProductEdit />} />
    },
    {
      path: 'product/package/create',
      element: <AuthGuard navId={'product'} component={<PackageCreate />} />
    },
    {
      path: 'product/package/:productId',
      element: <AuthGuard navId={'product'} component={<PackageEdit />} />
    },
    
    {
      path: 'suppliers',
      element: <AuthGuard navId={'suppliers'} component={<SupplierTable />} />
    },
    {
      path: 'supplier/create',
      element: <AuthGuard navId={'supplier'} component={<SupplierCreate />} />
    },
    {
      path: 'supplier/edit/:id',
      element: <AuthGuard navId={'supplier'} component={<SupplierEdit />} />
    },
    {
      path: 'receipts',
      element: <AuthGuard navId={'receipts'} component={<ReceiptTable />}/>
    },
    {
      path: 'receipt/edit/:id',
      element: <AuthGuard navId={'receipt'} component={<ReceiptEdit />}/>
    },
    {
      path: 'receipt/copy/:id',
      element: <AuthGuard navId={'receipt'} component={<ReceiptCopy />} />
    },
    {
      path: 'receipt/print/:id',
      element: <AuthGuard navId={'receipt'} component={<ReceiptPrint />}/>
    },
    {
      path: 'receipt/multiprint/:ids',
      element: <AuthGuard navId={'receipt'} component={<MultiReceiptsPrint />}/>
    },
    {
      path: 'orders',
      element: <AuthGuard navId={'orders'} component={<OrdersTabsPage />}/>
    },
    {
      path: 'order/copy/:id',
      element: <AuthGuard navId={'order'} component={<OrderCopy />} />
    },
    {
      path: 'order/edit/:id',
      element: <AuthGuard navId={'order'} component={<OrderEdit />} />
    },
    // {
    //   path: 'orders/:orderId/details/new',
    //   element: <AuthGuard navId={'order'} component={<CustomerOrderDetailsDialog />} />
    // },
    // {
    //   path: 'orders/:orderId/details/:detailId/edit',
    //   element: <AuthGuard navId={'order'} component={<CustomerOrderDetailsEdit />} />
    // },
    {
      path: 'order/:orderId/details',
      element: <AuthGuard navId={'order'} component={<CustomerOrderDetailsPage />}/>
    },
    {
      path: 'purchaseOrder',
      element: <AuthGuard navId={'purchaseOrder'} component={<PurchaseOrderTable />}/>
    },
    {
      path: 'purchaseOrder/create',
      element: <AuthGuard navId={'purchaseOrder'} component={<PurchaseOrderCreate />} />
    },
    {
      path: 'purchaseOrder/edit/:id',
      element: <AuthGuard navId={'purchaseOrder'} component={<PurchaseOrderEdit />} />
    },
    {
      path: 'treatments/settings',
      element: <AuthGuard navId={'treatmentConsumables'} component={<TreatmentConsumablesSettingsTable />} />
    },
    {
      path: 'treatments/:productId/consumables',
      element: <AuthGuard navId={'treatmentConsumables'} component={<TreatmentConsumablesTable />} />
    },
    {
      path: 'treatments/usage',
      element: <AuthGuard navId={'treatmentUsage'} component={<TreatmentUsageList />} />
    },
    {
      path: 'treatments/:treatmentId/usage/:productId',
      element: <AuthGuard navId={'treatmentUsageDetail'} component={<TreatmentUsageDetail />} />
    },
    {
      path: 'inventory',
      element: <AuthGuard navId={'inventory'} component={<InventoryTable />} />
    },
    {
      path: 'inventory/initial',
      element: <AuthGuard navId={'inventory'} component={<InitialInventoryTable />} />
    },
    {
      path: 'inventory/initial/create',
      element: <AuthGuard navId={'inventory'} component={<InitialInventoryCreate />} />
    },
    {
      path: 'inventory/initial/edit/:id',
      element: <AuthGuard navId={'inventory'} component={<InitialInventoryEdit />} />
    },
    {
      path: 'inventory/adjustments',
      element: <AuthGuard navId={'inventory'} component={<InventoryAdjustmentTable />} />
    },
    {
      path: 'inventory/adjustments/create',
      element: <AuthGuard navId={'inventory'} component={<InventoryAdjustmentCreate />} />
    },
    {
      path: 'inventory/adjustments/edit/:id',
      element: <AuthGuard navId={'inventory'} component={<InventoryAdjustmentEdit />} />
    },
    {
      path: 'inventory/barchart',
      element: <AuthGuard navId={'inventory'} component={<InventoryBarChart />} />
    },    
    {
      path: 'lowStockList',
      element: <AuthGuard navId={'lowStockList'} component={<LowStockList />} />
    },
    {
      path: 'bills',
      element: <AuthGuard navId={'bills'} component={<BillTable />} />
    },
    {
      path: 'bill/edit/:id',
      element: <AuthGuard navId={'bill'} component={<BillEdit />} />
    },
    {
      path: 'payments',
      element: <AuthGuard navId={'payments'} component={<PaymentTable />} />
    },
    {
      path: 'payments/visit/:id',
      element: <AuthGuard navId={'payments'} component={<PaymentDetailsPage />} />
    },
    {
      path: 'credits',
      element: <AuthGuard navId={'credits'} component={<CreditTable />} />
    },
    {
      path: 'credit/edit/:id',
      element: <AuthGuard navId={'credit'} component={<CreditEdit />} />
    },
    {
      path: 'credit/product',
      element: <AuthGuard navId={'credit'} component={<FamilyCreditSessionByProductTable />} />
    },
    {
      path: 'credit/family',
      element: <AuthGuard navId={'credit'} component={<FamilyHistoryCreditTable />} />
    },
    {
      path: 'credit/familybalance',
      element: <AuthGuard navId={'credit'} component={<FamilyCreditBalance />} />
    },
    {
      path: 'credit/initial',
      element: <AuthGuard navId={'credit'} component={<InitialFamilyCreditTable />} />
    },
    {
      path: 'families/:familyId/products/:productId/history',
      element: <AuthGuard navId={'credit'} component={<FamilyProductHistory />} />
    },
    // {
    //   path: 'credit/product',
    //   element: <AuthGuard navId={'credit'} component={<FamilyBalancePage />} />
    // },
    {
      path: 'credit/initialTreatmentBalance',
      element: <AuthGuard navId={'credit'} component={<InitialTreatmentBalance />} />
    },
    {
      path: 'licences',
      element: <AuthGuard navId={'licences'} component={<LicenceTable />} />
    },
    {
      path: 'licenceBoard',
      element: <AuthGuard navId={'licenceBoard'} component={<LicenceBoard />} />
    },
    {
      path: 'licence/edit/:id',
      element: <AuthGuard navId={'licence'} component={<LicenceEdit />} />
    },
    {
      path: 'licence/create',
      element: <AuthGuard navId={'licence'} component={<LicenceCreate />} />
    },
    {
      path: 'schedule',
      element: <AuthGuard navId={'schedule'} component={<DailySchedule />} />
    },
    {
      path: 'clientSchedule',
      element: <Navigate to="/clientBooking" replace />
    },
    {
      path: 'clientBooking',
      element: <ClientBookingPage />
    },
    {
      path: 'clientSettings',
      element: <AuthGuard navId={'clientSchedule'} component={<ClientSettingsPage />} />
    },
    {
      path: 'appointment',
      element: <AuthGuard navId={'appointment'} component={<AppointmentSchedule />} />
    },
    {
      path: 'rooms',
      element: <AuthGuard navId={'rooms'} component={<RoomTable />} />
    },
    {
      path: 'rooms/create',
      element: <AuthGuard navId={'rooms'} component={<RoomEdit />} />
    },
    {
      path: 'rooms/edit/:roomId',
      element: <AuthGuard navId={'rooms'} component={<RoomEdit />} />
    },
    {
      path: 'licenceSchedule/:licenceUserId',
      element: <AuthGuard navId={'licenceSchedule'} component={<LicenceSchedule />} />
    },
    {
      path: 'insuranceSchedule/:licenceUserId',
      element: <AuthGuard navId={'insuranceSchedule'} component={<InsuranceSchedule />} />
    },
    {
      path: 'wages',
      element: <AuthGuard navId={'wages'} component={<WageTable />} />
    },
    {
      path: 'wage/edit/:id',
      element: <AuthGuard navId={'wage'} component={<WageEdit />} />
    },
    {
      path: 'fixedWage',
      element: <AuthGuard navId={'fixedWage'} component={<FixedWageTable />} />
    },
    {
      path: 'WageBoard',
      element: <AuthGuard navId={'wageBoard'} component={<WageBoard />} />
    },
    {
      path: 'wageSummaryHome',
      element: <AuthGuard navId={'wageSummaryHome'} component={<WageSummaryHome />} />
    },
    {
      path: 'wageSummaryBoard',
      element: <AuthGuard navId={'wageSummaryBoard'} component={<WageSummaryBoard />} />
    },
    {
      path: 'wageSummaryDetail/:userId/:payPeriod/:startDate/:endDate',
      element: <AuthGuard navId={'WageSummaryDetail'} component={<WageSummaryDetail />} />
    },
    {
      path: 'receiptSummaryHome',
      element: <AuthGuard navId={'receiptSummaryHome'} component={<ReceiptSummaryHome />} />
    },
    {
      path: 'receiptSummaryDetail/:userId/:payPeriod/:startDate/:endDate',
      element: <AuthGuard navId={'receiptSummaryDetail'} component={<ReceiptSummaryDetail />} />
    },
    {
      path: 'timesheets',
      element: <AuthGuard  navId={'timesheets'} component={<TimesheetTable />} />
    },
    {
      path: 'timesheetBoard',
      element: <AuthGuard  navId={'timesheetBoard'} component={<TimesheetBoard />} />
    },
    {
      path: 'commission',
      element: <AuthGuard  navId={'commission'} component={<CommissionTable />} />
    },
    {
      path: 'commissionBoard',
      element: <AuthGuard  navId={'commissionBoard'} component={<CommissionBoard />} />
    },
    {
      path: 'timesheet/create',
      element: <AuthGuard  navId={'timesheet'} component={<TimesheetCreate />} />
    },
    {
      path: 'timesheet/edit/:id',
      element: <AuthGuard  navId={'timesheet'} component={<TimesheetEdit />} />
    },
    {
      path: 'systemSetting/scheduleSort',
      element: <AuthGuard navId={'systemSettingScheduleSort'} component={<SystemSettingScheduleSort />} />
    },
    {
      path: 'systemSetting/creditType',
      element: <AuthGuard navId={'systemSettingCreditType'} component={<SystemSettingCreditTypeTable />} />
    },
    {
      path: 'systemSetting/receiptType',
      element: <AuthGuard navId={'receiptTypeTable'} component={<ReceiptTypeTable />} />
    },
    {
      path: 'systemSetting/pagePermitTable',
      element: <AuthGuard navId={'pagePermitTable'} component={<PagePermitTable />} />
    },
    {
      path: 'systemSetting/pagePermit/edit/:id',
      element: <AuthGuard navId={'pagePermitEdit'} component={<PagePermitEdit />} />
    },
    {
      path: 'systemSetting/moduleNavAclTable',
      element: <AuthGuard navId={'moduleNavAclTable'} component={<ModuleNavAclTable />} />
    },
    {
      path: 'systemSetting/moduleNav/:id',
      element: <AuthGuard navId={'moduleNavAclEdit'} component={<ModuleNavAclEdit />} />
    },
    {
      path: 'systemSetting/userWageTable',
      element: <AuthGuard navId={'userWageTable'} component={<UserWageTable />} />
    },
    // {
    //   path: 'systemSetting/wageCategoryEdit/:id',
    //   element: <AuthGuard navId={'wageCategoryEdit'} component={<WageCategoryEdit />} />
    // },
    {
      path: 'systemSetting/userWageDetailTable/:userId',
      element: <AuthGuard navId={'userWageDetailTable'} component={<UserWageDetailTable />} />
    },
    {
      path: 'systemSetting/paymentMethodSetting',
      element: <AuthGuard navId={'paymentMethodSetting'} component={<PaymentMethodSetting />} />
    },
    {
      path: 'systemSetting/clinicRuntime',
      element: <AuthGuard navId={'clinicRuntimeSetting'} component={<ClinicRuntimeSetting />} />
    },
    {
      path: 'systemSetting/customisedSetting',
      element: <AuthGuard navId={'customisedSetting'} component={<CustomisedSettingTable />} />
    },
    {
      path: 'systemSetting/customisedSetting/edit/:id',
      element: <AuthGuard navId={'customisedSettingEdit'} component={<CustomisedSettingEdit />} />
    },
    {
      path: 'expenses',
      element: <AuthGuard navId={'expense'} component={<ExpenseTable />} />
    },
    {
      path: 'expense/create',
      element: <AuthGuard  navId={'expense'} component={<ExpenseCreate />} />
    },
    {
      path: 'expense/edit/:id',
      element: <AuthGuard  navId={'expense'} component={<ExpenseEdit />} />
    },
    {
      path: 'sales',
      element: <AuthGuard navId={'sales'} component={<SalesTable />} />
    },
    {
      path: 'managerReport',
      element: <AuthGuard navId={'managerReport'} component={<ManagerReport />} />
    },
    {
      path: 'staffDailyReport',
      element: <AuthGuard navId={'staffDailyReport'} component={<StaffDailyReport />} />
    },
    {
      path: 'revenue',
      element: <AuthGuard navId={'revenue'} component={<RevenueTable />} />
    },
    {
      path: 'dailyreport',
      element: <AuthGuard navId={'dailyreport'} component={<DailyReportPage />} />
    },
    {
      path: 'ownerGrowthEngine',
      element: <AuthGuard navId={'ownerGrowthEngine'} component={<ClientGrowthEngine />} />
    },
    {
      path: 'ownerGrowthEngine/help',
      element: <AuthGuard navId={'ownerGrowthEngine'} component={<ClientGrowthEngineHelp />} />
    },
    {
      path: 'fixedExpense',
      element: <AuthGuard navId={'fixedExpense'} component={<FixedExpensePage />} />
    },
    {
      path: 'variableExpense',
      element: <AuthGuard navId={'vatriableExpense'} component={<VariableExpenseTable />} />
    },
    {
      path: 'monthlySummary',
      element: <AuthGuard navId={'monthlySummary'} component={<MonthlySummary />} />
    },
    {
      path: 'revenueSummary',
      element: <AuthGuard navId={'revenueSummary'} component={<RevenueSummaryPage />} />
    },
    {
      path: 'help',
      element: <AuthGuard navId={'help'} component={<HelpTable />} />
    },
    {
      path: 'logout',
      element: <AuthGuard navId={'public'} component={<AuthLogout />} />
    },
    {
      path: '404',
      element: <AuthGuard navId={'public'} component={<Error404 />} />
    },
    {
      path: '*',
      element: <AuthGuard navId={'public'} component={<Error404 />} />
    }
  ]
}

export default MainRoutes
